<template>
  <div id="section-3" class="container-fluid mt-3 bg-white">
    <div class="row">
      <div class="vision-label">
        <span class="text-uppercase font-basetheme font-3x">Vision</span>
        <div class="font-sarabun font-3x font-secondtheme">“</div>เราเป็นผู้จัดหาและพัฒนาเทคโนโลยีแบบครบวงจร
        <br />เพื่อตอบโจทย์ธุรกิจทั้งในประเทศและต่างประเทศ
        <!-- <div class="font-sarabun font-2x font-secondtheme">”</div> -->
      </div>
      <img src="@/assets/img/home/eye-1132531_640.jpg" class="w-100" alt="..." />
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>